import React from 'react';
import './About.css';

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="section-header">
          <h2>About The New Waves Group</h2>
          <p>An umbrella organization driving innovation across multiple sectors</p>
        </div>
        <div className="about-content">
          <div className="about-text">
            <p>
              The New Waves Group Limited is a diversified holding company that operates 
              through three strategic subsidiaries, each specializing in distinct sectors 
              of the economy. Our integrated approach allows us to deliver comprehensive 
              solutions across telecommunications, project management, and real estate development.
            </p>
            <div className="stats">
              <div className="stat">
                <h3>3</h3>
                <p>Subsidiary Companies</p>
              </div>
              <div className="stat">
                <h3>100+</h3>
                <p>Projects Completed</p>
              </div>
              <div className="stat">
                <h3>10+</h3>
                <p>Years Experience</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
